import React from 'react';
import "./Loader.scss";
import img from "./loader.png";

const Loader = () => {
  return (
    <div className="Loader">
      <img src={img} alt="Loading..." />
    </div>
  );
}

export default Loader;
